import clsx from 'clsx'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

type IProps = {
  icon: JSX.Element
  title: string
  classes?: string
}
const TitleHeader: FC<IProps> = ({ icon, title, classes }) => {
  const { t } = useTranslation()
  return (
    <p
      className={clsx(
        classes,
        'flex md:col-start-1 md:col-end-5 text-sm bg-blue-100 text-blue-500 py-2 px-4 rounded-lg mb-3 md:mt-0 mt-3',
      )}
    >
      <span className='ml-2'>{icon}</span>
      <span>{t(title)}</span>
    </p>
  )
}

export default TitleHeader
